import { isTestEnvironment } from './isTestEnvironment';

// Dev and prod otherwise have the same favicon and tab title, which has led to work being
// done in the wrong one.
export const markTestEnvironment = () => {
  if (!isTestEnvironment()) {
    return;
  }
  document.title = 'Microniq - Dev';
  document
    .querySelector<HTMLLinkElement>('link[rel="icon"]')
    ?.setAttribute('href', '/micronIq_icon_dev.png');
};
